import React from 'react';
import styles from '../../settings/configuration/shared/IntelligencePanel.module.scss';

interface IntelligencePackCardsProps {
  packs: Array<{
    id: string;
    name: string;
    credits: number;
    price: number;
  }>;
  pendingDescription?: string | null;
  onSelect: (pack: {
    id: string;
    name: string;
    price: number;
    credits: number;
  }) => void;
}

const IntelligencePackCards: React.FC<IntelligencePackCardsProps> = ({
  packs,
  pendingDescription,
  onSelect,
}) => {
  const pending = Boolean(pendingDescription);
  return (
    <div className={styles.packs}>
      <h6 className={styles.packsTitle}>Paquetes de créditos</h6>
      <p className={styles.hint}>
        {pending
          ? `Pago en revisión: ${pendingDescription}. No puedes comprar otro paquete hasta que se apruebe o rechace.`
          : 'Para el periodo actual. Elige un paquete para comprar.'}
      </p>
      <div className={styles.packList}>
        {packs.map(pack => (
          <button
            key={pack.id}
            type="button"
            className={styles.packItem}
            onClick={() => onSelect(pack)}
            disabled={pending}
          >
            <span className={styles.cardLabel}>{pack.name}</span>
            <span className={styles.cardPrice}>
              ${Number(pack.price).toFixed(2)}
            </span>
            <span className={styles.cardMeta}>
              {Number(pack.credits).toLocaleString()} créditos
            </span>
            <span className={styles.packCta}>
              {pending ? 'En revisión' : 'Comprar'}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default IntelligencePackCards;
